import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PasskeyRegisterState {
  loading: boolean;
  success: any;
  error: any | null;
  otpRequired: boolean;
  passkeyToken: string | null;
}

const initialState: PasskeyRegisterState = {
  loading: false,
  success: null,
  error: null,
  otpRequired: false,
  passkeyToken: null,
};

const passkeyRegisterSlice = createSlice({
  name: 'passkeyRegister',
  initialState,
  reducers: {
    passkeyRegisterRequest(
      state,
      _action: PayloadAction<{
        apiName: string;
        data: {
          webauthn_encoded_result: string;
          accountId: string;
          customerId: string;
          username: string;
          flow: string;
        };
      }>
    ) {
      state.loading = true;
      state.success = null;
      state.error = null;
      state.otpRequired = false;
      state.passkeyToken = null;
    },
    passkeyRegisterSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.success = action.payload ?? true;
      state.error = null;
      state.otpRequired = false;
      state.passkeyToken = null;
    },
    passkeyRegisterOtpRequired(
      state,
      action: PayloadAction<{ passkeyToken: string }>
    ) {
      state.loading = false;
      state.success = null;
      state.error = null;
      state.otpRequired = true;
      state.passkeyToken = action.payload.passkeyToken;
    },
    passkeyRegisterFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.success = null;
      state.error = action.payload;
      state.otpRequired = false;
      state.passkeyToken = null;
    },
    resetPasskeyRegisterState() {
      return initialState;
    },
  },
});

export const {
  passkeyRegisterRequest,
  passkeyRegisterSuccess,
  passkeyRegisterOtpRequired,
  passkeyRegisterFailed,
  resetPasskeyRegisterState,
} = passkeyRegisterSlice.actions;

export default passkeyRegisterSlice.reducer;
